import { render, staticRenderFns } from "./routerView.vue?vue&type=template&id=ede2ed2e&scoped=true"
import script from "./routerView.vue?vue&type=script&lang=js"
export * from "./routerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede2ed2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ede2ed2e')) {
      api.createRecord('ede2ed2e', component.options)
    } else {
      api.reload('ede2ed2e', component.options)
    }
    module.hot.accept("./routerView.vue?vue&type=template&id=ede2ed2e&scoped=true", function () {
      api.rerender('ede2ed2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/routerView.vue"
export default component.exports